import React from "react";
import ReactDOMServer from "react-dom/server";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import ButtonTable from "../common/table/buttonTable";
import Button from "../common/button/button";
import Form from "./faturaAguaForm";
import FormatUtils from "../common/formatUtils/FormatUtils";

import { DisplayPDF } from "../displayPDF/displayPDF";

import TabelaFaturaAdmPDF from "../htmlToPdf/TabelaFaturaAdmPDF";
import {
    setModoTela,
    initForm,
    setFiltro,
    salvar,
    excluir,
    getListaFaturasAdm,
    buscarPdf,
    setAguardando,
    gerarRelatorio,
    reprocessar,
    reprocessarTodas,
    setAlertaVerificado,
} from "./faturaAguaActions";

import { setArquivoPDF } from "../displayPDF/displayPDFActions";

import { Loading } from "../common/loading/loading";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar";
import { setError } from "../common/toast/toast";
import { ModalAlert } from "../common/dialog/modalAlert";
import DateFormat from "../common/dateFormat/DateFormat";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria";
import { useState } from "react";
import { useEffect } from "react";
import { BotaoGerarRelatorio } from "../common/button/BotaoGerarRelatorio";
import { FiltrosFaturasAdmAgua } from "./components/FiltrosFaturasAdmAgua";

const INITIAL_STATE = {
    statusTodasCores: true,
    statusCorBranca: true,
    statusCorVerde: true,
    statusCorAmarela: true,
    statusCorVermelha: true,
    apenasUnidadesEmImplantacao: false,
    apenasAlertas: false,
    apenasAlertasVerificados: false,
    exibirErros: false,
    itemPdfSelecionado: null,
    conteudoModalAlertaErros: null,
    exibirModalGestorConcessionaria: false,
    itemSelecionado: null,
};

const INITIAL_TOTAIS = {
    valorTotal: 0,
    consumoTotal: 0,
    quantidadeUnidadesFiltradas: 0,
    qtdCorBranca: 0,
    qtdCorVerde: 0,
    qtdCorAmarela: 0,
    qtdCorVermelha: 0,
    qtdCorVermelhaAlertas: 0,
    qtdUnidadesEmImplantacao: 0,
};

const CORES = {
    BRANCA: { backgroundColorTr: "rgb(255, 255, 255)", backgroundColorTd: "rgb(245, 245, 245)" },
    //se estiver paga retorna verde
    VERDE: { backgroundColorTr: "rgb(221, 255, 221)", backgroundColorTd: "rgb(68, 255, 170)" },
    AZUL: {
        backgroundColorTr: "rgb(243 255 255)",
        backgroundColorTd: "rgb(197 255 255)",
    },
    AMARELA: {
        backgroundColorTr: "rgb(255 255 212)",
        backgroundColorTd: "rgb(255 239 113)",
    },
    VERMELHA: {
        backgroundColorTr: "rgb(251 202 202)",
        backgroundColorTd: "rgb(255 101 105)",
    },
    VERMELHA_ALERTA: {
        backgroundColorTr: "#FC5959",
        backgroundColorTd: "#C40D11",
    },
};

function FaturaAguaAdm(props) {
    if (!props.usuarioLogado || props.usuarioLogado.acesso_cliente) return <div style={{ color: "red" }}>Acesso Negado.</div>;

    // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/faturaAgua.js (incluir, editar, excluir, importar, validarImportacao) e nos endpoints POST, PUT e DELETE /api/fatura-agua
    const usuarioAcessoEditar = props.usuarioLogado && (props.usuarioLogado.acesso_fatura_editar || props.usuarioLogado.acesso_fatura_editar_fechado);

    const [faturasFiltradas, setFaturasFiltradas] = useState([]);
    const [state, setState] = useState(INITIAL_STATE);
    const [totais, setTotais] = useState(INITIAL_TOTAIS);

    function handleResetStates() {
        setFaturasFiltradas([]);
        setTotais(INITIAL_TOTAIS);
    }

    useEffect(() => {
        props.getListaFaturasAdm();
    }, []);

    useEffect(() => {
        handleResetStates();
        props.getListaFaturasAdm();
    }, [props.filtro]);

    useEffect(() => {
        if (!props.usuarioLogado) return;
        const listaAtualizada = [];
        const totaisAtualizados = { ...INITIAL_TOTAIS };
        for (const item of props.lista) {
            if (!itemCorrespondeAoFiltro(item)) {
                // console.log("uc" + item.id_unidade_consumidora + " IGNORADA");
                continue;
            }
            listaAtualizada.push(item);
            contabilizarTotais({ item, totais: totaisAtualizados });
            // console.log(item.id_unidade_consumidora + " INCLUIDO");
        }

        setFaturasFiltradas(listaAtualizada);
        setTotais(totaisAtualizados);
    }, [
        props.lista,
        props.usuarioLogado,
        props.filtro,
        state.statusCorAzul,
        state.statusCorAmarela,
        state.statusCorVermelha,
        state.statusCorVerde,
        state.statusCorBranca,
        state.apenasUnidadesEmImplantacao,
        state.apenasAlertas,
        state.apenasAlertasVerificados,
    ]);

    //os itens de fatura de agua tem esse campo erros, se não tiver, é pq ainda ta carregada a lista de energia
    return (
        <div>
            {props.pdf ? <DisplayPDF closePdf={props.setArquivoPDF} pdfBase64={props.pdf} nomePdf={props.nomePdf} orientation={props.orientation} zoomParametro={1.5} /> : null}
            {props.aguardando ? <Loading /> : null}
            {state.exibirErros ? (
                <ModalAlert titulo="" handleClose={() => fecharModalAlertaErros()}>
                    {state.conteudoModalAlertaErros}
                </ModalAlert>
            ) : null}

            <Content>
                <div style={props.pdf ? { display: "none" } : {}}>
                    {props.modoTela === "visualizacao" ? <Form visualizar /> : null}
                    {props.modoTela === "cadastro" ? <Form onSubmit={props.salvar} /> : null}
                    {props.modoTela === "exclusao" ? <Form excluir onSubmit={props.excluir} /> : null}
                    {props.modoTela === "lista" ? lista() : null}
                </div>
            </Content>
        </div>
    );

    function contabilizarTotais({ item, totais }) {
        totais.quantidadeUnidadesFiltradas++;

        totais.valorTotal += parseFloat(item.valor_fatura > 0 ? item.valor_fatura : 0);
        totais.consumoTotal += parseFloat(item.quantidade_agua_consumida || 0);

        switch (item.cor) {
            case "AZUL":
                totais.qtdCorAzul++;
                break;
            case "AMARELA":
                totais.qtdCorAmarela++;
                break;
            case "VERDE":
                totais.qtdCorVerde++;
                break;
            case "VERMELHA":
                totais.qtdCorVermelha++;
                break;
            case "BRANCA":
                totais.qtdCorBranca++;
                break;
            default:
                break;
        }
        if (item.alertas.length && !item.alerta_verificado && item.importacao_validada) {
            totais.qtdCorVermelhaAlertas++;
        }

        if (item.id_usuario_implantacao) {
            totais.qtdUnidadesEmImplantacao++;
        }
    }

    function montarBotoes(item) {
        const botoes = [];
        if (!item) return botoes;
        const eventoForm = (modo) => {
            props.setModoTela(modo, {
                ...item,
                competencia: item.competencia_formatada,
                valor_fatura: FormatUtils.formatarValorTela(item.valor_fatura, 2),
                quantidade_agua_consumida: FormatUtils.formatarValorTela(item.quantidade_agua_consumida, 2),
            });
            props.initForm({
                ...item,
                competencia: item.competencia_formatada,
                valor_fatura: FormatUtils.formatarValorTela(item.valor_fatura, 2),
                quantidade_agua_consumida: FormatUtils.formatarValorTela(item.quantidade_agua_consumida, 2),
            });
        };
        if (item.arquivo_pdf) {
            if (props.usuarioLogado && !props.usuarioLogado.acesso_cliente) {
                botoes.push(
                    {
                        type: "success",
                        icon: "fas fa-sync",
                        // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/faturaAgua.js (reprocessar) e no endpoint POST /api/fatura-agua/reprocessar
                        disabled: !item.arquivo_pdf || !props.usuarioLogado.acesso_fatura_reprocessar,
                        event: () => {
                            props.reprocessar(item.id);
                        },
                    },

                    {
                        type: "primary",
                        icon: "fas fa-eye",
                        disabled: !props.usuarioLogado.acesso_fatura_visualizar,
                        event: () => eventoForm("visualizacao"),
                    },

                    {
                        type: "warning",
                        icon: "fas fa-pencil-alt",
                        disabled: !usuarioAcessoEditar,
                        event: () => eventoForm("cadastro"),
                    },
                    {
                        type: "danger",
                        icon: "fas fa-trash-alt",
                        disabled: item.importacao_validada && !usuarioAcessoEditar,
                        event: () => eventoForm("exclusao"),
                    }
                );
            } else {
                if (usuarioAcessoEditar) {
                    botoes.push({
                        type: "success",
                        icon: "fas fa-eye",
                        event: () => eventoForm(""),
                    });
                }
            }
        } else {
            if (usuarioAcessoEditar) {
                if (item.id) {
                    botoes.push({
                        style: { width: 90 },
                        text: "Excluir",
                        type: "danger",
                        solid: true,
                        disabled: item.importacao_validada && !usuarioAcessoEditar,
                        event: () => eventoForm("exclusao"),
                    });
                } else {
                    botoes.push({
                        style: { width: 90 },
                        text: "Importar",
                        type: "success",
                        solid: true,
                        disabled: !usuarioAcessoEditar,
                        event: () => eventoForm("cadastro"),
                    });
                }
            }
        }

        return botoes;
    }

    function buildRow({ item, indice = 0, getOnlyComponent = false }) {
        const botoes = montarBotoes(item);

        const { backgroundColorTd, backgroundColorTr } = definirCores(item);

        const { msgErroImportacaoHtml, msgErroImportacaoText } = getMensagensErro(item);
        const { msgAlertaImportacaoHtml, msgAlertaImportacaoText } = getMensagensAlerta({ item });

        const mensagensImportacao = `DOWNLOAD E IMPORTAÇÃO - ${item.mensagem_ultima_importacao_fatura_agua || "Sem informação"}\nDATA DE PAGAMENTO - ${
            item.mensagem_ultima_importacao_data_pagamento_agua || "Sem informação"
        }`;

        const existeMensagensErro = (String(mensagensImportacao).match(/OK/g) || []).length < 2;

        const linha = (
            <NewTr key={`${item.id_unidade_consumidora_agua}-${item.id}-adm-agua`} backgroundColorTr={backgroundColorTr} backgroundColorTd={backgroundColorTd} botoes={botoes}>
                <Td fontSize="0.85rem" width={160}>
                    <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: 138 }}>
                        {item.id_usuario_implantacao ? (
                            <p
                                style={{
                                    backgroundColor: "#257bfb",
                                    textAlign: "center",
                                    borderRadius: "0.3rem",
                                    color: "#ffffff",
                                    margin: "0 10px 2px",
                                    padding: "2px 5px",
                                    fontSize: "0.875rem",
                                }}
                            >
                                Implantação
                            </p>
                        ) : null}

                        <p
                            style={{
                                textAlign: "center",
                                padding: "0px 15px 0px 5px",
                                margin: 0,
                            }}
                        >
                            {msgErroImportacaoText.includes("Verifique") ? (
                                <Button
                                    style={{ padding: "2px 5px" }}
                                    title={msgErroImportacaoText}
                                    text={<div style={{ textWrap: "nowrap" }}>{item.alerta_verificado ? "Erros Revisados" : "Exibir Erros"}</div>}
                                    solid={true}
                                    type={"danger"}
                                    event={() => {
                                        setState({
                                            ...state,
                                            exibirErros: true,
                                            conteudoModalAlertaErros: msgErroImportacaoHtml,
                                        });
                                        // window.alert(mensagensErroText);
                                    }}
                                />
                            ) : (
                                msgErroImportacaoHtml
                            )}
                            {msgAlertaImportacaoText.includes("Verifique") ? (
                                <Button
                                    style={{ padding: "2px 5px", marginTop: 2 }}
                                    title={msgAlertaImportacaoText}
                                    text={<div style={{ textWrap: "nowrap" }}>{item.alerta_verificado ? "Alertas Revisados" : "Exibir Alertas"}</div>}
                                    solid={true}
                                    type={item.alerta_verificado ? "success" : "warning"}
                                    event={() => {
                                        setState({
                                            ...state,
                                            exibirErros: true,
                                            conteudoModalAlertaErros: msgAlertaImportacaoHtml,
                                        });
                                        // window.alert(mensagensErroText);
                                    }}
                                />
                            ) : null}
                        </p>
                        {item.datahora_importacao_fatura ? (
                            <p
                                style={{
                                    textAlign: "center",
                                    color: "#222",
                                    margin: "4px 10px 2px",
                                    padding: "2px 5px",
                                    fontSize: "0.6",
                                    lineHeight: "0.85rem",
                                    backgroundColor: "#fefefe",
                                    borderRadius: "3px",
                                }}
                            >
                                Importada em {item.datahora_importacao_fatura} pelo {item.nome_usuario_importacao_fatura}
                            </p>
                        ) : null}
                    </div>
                </Td>

                <Td fontSize="0.85rem" minWidth={50} alignCenter>
                    {item.competencia_formatada}
                </Td>
                <Td fontSize="0.85rem" minWidth={80}>
                    {item.nome_cliente}
                </Td>
                <Td minWidth={150}>
                    <div>
                        {item.data_emissao ? (
                            <p
                                style={{
                                    textAlign: "center",
                                    fontSize: "0.8rem",
                                    margin: "0 0 5px 0",
                                }}
                            >
                                Emitida em: {DateFormat.formatarDataSqlParaTela(item.data_emissao)}{" "}
                            </p>
                        ) : null}
                    </div>
                </Td>

                <Td fontSize="0.85rem" minWidth={120}>
                    {item.nome_unidade_consumidora + " (" + item.nome_concessionaria + ")"}
                </Td>

                <Td fontSize="0.85rem" minWidth={50} alignCenter>
                    {adicionarPontosMilhar(item.valor_fatura || 0)}
                </Td>
                <Td fontSize="0.85rem" minWidth={50} alignCenter>
                    {adicionarPontosMilhar(item.quantidade_agua_consumida || 0)}
                </Td>
                <Td alignCenter minWidth={50}>
                    {item.arquivo_pdf && (!(item.erros || []).length || item.importacao_validada || props.usuarioLogado.administrador) ? (
                        <ButtonTable
                            style={{ margin: 0 }}
                            title="Visualizar PDF"
                            type={"primary"}
                            icon={"fas fa-file-pdf"}
                            visible={true}
                            event={() => {
                                props.buscarPdf(
                                    item.id,
                                    `Fatura_UC-${item.nome_unidade_consumidora.split("-")[0].trim()}_${String(item.competencia).substring(4, 6)}-${String(
                                        item.competencia
                                    ).substring(0, 4)}`
                                );
                                props.setArquivoPDF();
                            }}
                        />
                    ) : existeMensagensErro ? (
                        <ButtonTable
                            solid={true}
                            style={{
                                margin: 0,
                                borderRadius: "0.3rem",
                            }}
                            title={mensagensImportacao}
                            type={"danger"}
                            icon={"fas fa-exclamation"}
                            visible={true}
                            event={() => ({})}
                        />
                    ) : null}
                </Td>
            </NewTr>
        );

        if (getOnlyComponent) {
            return linha;
        }

        return {
            componente: linha,
            msgErroImportacaoText,
            msgAlertaImportacaoText,
            id_usuario_implantacao: item.id_usuario_implantacao,
            data_emissao: item.data_emissao,
            nome_cliente: item.nome_cliente,
            nome_concessionaria: item.nome_concessionaria,
            nome_unidade_consumidora: item.nome_unidade_consumidora,
        };
    }

    function definirCores(item) {
        let backgroundColorTd = CORES[item.cor] ? CORES[item.cor].backgroundColorTd : "#3f3f3f";
        let backgroundColorTr = CORES[item.cor] ? CORES[item.cor].backgroundColorTr : "#585858";

        //forçar status vermelho quando tarifa média liquida for inválida ou tiver alertas, desde que o alerta não esteja verificado
        //as isentas continua mostrando como azul, apesar de ter um alerta
        if (item.alertas.length && !item.alerta_verificado && item.importacao_validada) {
            backgroundColorTd = CORES["VERMELHA_ALERTA"].backgroundColorTd;
            backgroundColorTr = CORES["VERMELHA_ALERTA"].backgroundColorTr;
        }

        return { backgroundColorTd, backgroundColorTr };
    }

    function lista() {
        let statusAtivos = [];
        if (state.statusCorBranca) statusAtivos.push("Faturas não importadas");
        if (state.statusCorVerde) statusAtivos.push("Faturas validadas e sem erros");
        if (state.statusCorAmarela) statusAtivos.push("Faturas corrigidas");
        if (state.statusCorVermelha) statusAtivos.push("Faturas com necessidade de correção");
        if (state.statusCorBranca && state.statusCorVerde && state.statusCorAmarela && state.statusCorVermelha) statusAtivos = "Todas as faturas";

        //DADOS PARA IMPRESSÃO DO RELATÓRIO ---------------
        const cabecalho = (
            <NewTr backgroundColorTr="#FFFFFF" backgroundColorTd="#F9F9F9">
                <Th sticky style={{ fontSize: "0.85rem" }} minWidth={120} alignCenter title="Status da Importação das Faturas de Água">
                    Status Imp. Fatura
                </Th>
                <Th sticky style={{ fontSize: "0.85rem" }} minWidth={75} alignCenter>
                    Competência
                </Th>
                <Th sticky style={{ fontSize: "0.85rem" }} alignCenter minWidth={65}>
                    Cliente
                </Th>
                <Th sticky style={{ fontSize: "0.7rem" }} alignCenter>
                    Data de Emissão
                </Th>
                <Th sticky style={{ fontSize: "0.85rem" }} alignCenter minWidth={65}>
                    UC
                </Th>
                <Th sticky style={{ fontSize: "0.85rem" }} minWidth={65} alignCenter>
                    Valor Fatura (R$)
                </Th>
                <Th sticky style={{ fontSize: "0.85rem" }} minWidth={34} alignCenter>
                    Água Consumida (m³)
                </Th>
                <Th sticky style={{ fontSize: "0.85rem" }} alignCenter>
                    PDF
                </Th>
            </NewTr>
        );

        const rodape = (
            <Tr>
                <Td fontSize="0.85rem" fontWeight="bold">
                    Total
                </Td>
                <Td fontSize="0.85rem" fontWeight="bold">
                    Qtd. UC:{totais.quantidadeUnidadesFiltradas}
                </Td>
                <Td fontSize="0.85rem" fontWeight="bold"></Td>
                <Td fontSize="0.85rem" fontWeight="bold"></Td>
                <Td fontSize="0.85rem" fontWeight="bold"></Td>
                <Td fontSize="0.85rem" fontWeight="bold">
                    {adicionarPontosMilhar(totais.valorTotal)}
                </Td>
                <Td fontSize="0.85rem" fontWeight="bold">
                    {adicionarPontosMilhar(totais.consumoTotal)}
                </Td>
                <Td fontSize="0.85rem" fontWeight="bold"></Td>
            </Tr>
        );
        //------------------------------------------------

        function handleGerarPdf() {
            if (!props.filtro.unidades_consumidoras.length && !props.filtro.id_cliente && !props.filtro.id_concessionaria) {
                return setError("Selecione um cliente ou alguma unidade consumidora para gerar o relatório");
            }
            const linhas = montarLinhas(faturasFiltradas);
            gerarRelatorio({
                statusAtivos,
                cabecalho,
                rodape,
                linhas,
            });
        }

        const listaUcsFiltradas = listarUCsFiltradas();

        return (
            <ContentCard>
                <ModalGestorConcessonaria
                    tipo="agua"
                    visible={state.exibirModalGestorConcessionaria && state.itemSelecionado && state.itemSelecionado.gestor_concessionaria_agua}
                    itemSelecionado={state.itemSelecionado}
                    handleClose={() => setState({ ...state, exibirModalGestorConcessionaria: false, itemSelecionado: null })}
                />
                {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                    <ContentCardHeader>
                        <Row style={{ paddingRight: 5 }}>
                            <Grid cols="12 4 4 2">
                                <Button
                                    text="Adicionar"
                                    type={"success"}
                                    icon={"fa fa-plus"}
                                    style={{ marginTop: 28 }}
                                    disabled={!usuarioAcessoEditar || props.aguardando}
                                    event={() => {
                                        const dadosForm = {
                                            competencia: `${props.filtro.mes}/${props.filtro.ano}`,
                                            erros: [],
                                            alertas: [],
                                            valor_fatura: FormatUtils.formatarValorTela(0, 2),
                                            quantidade_agua_consumida: FormatUtils.formatarValorTela(0, 2),
                                        };
                                        props.setModoTela("cadastro", { ...dadosForm });
                                        props.initForm({ ...dadosForm });
                                    }}
                                />
                            </Grid>

                            {props.usuarioLogado &&
                            !props.usuarioLogado.acesso_cliente &&
                            props.usuarioLogado.acesso_fatura_reprocessar &&
                            (props.usuarioLogado.usuario_implantacao || [1, 2].includes(props.usuarioLogado.id)) /*INFINITUM e marthielo*/ ? (
                                <Grid cols="12 4 4 2">
                                    <Button
                                        text="Reprocessar"
                                        type={"success"}
                                        icon={"fa fa-sync"}
                                        style={{ marginTop: 28 }}
                                        // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/faturaAgua.js (reprocessar) e no endpoint POST /api/fatura-agua/reprocessar
                                        disabled={!props.usuarioLogado.acesso_fatura_reprocessar || props.aguardando}
                                        event={() => {
                                            props.reprocessarTodas(faturasFiltradas);
                                        }}
                                    />
                                </Grid>
                            ) : null}
                        </Row>
                    </ContentCardHeader>
                ) : null}

                <FiltrosFaturasAdmAgua
                    listaUnidadeConsumidora={listaUcsFiltradas}
                    setState={(novoFiltro) => setState(novoFiltro)}
                    filtroState={{ ...state }}
                    statusAtivos={statusAtivos}
                    quantidadesFiltro={{ ...totais }}
                    buttons={[<BotaoGerarRelatorio aguardando={props.aguardando} gerarPdf={handleGerarPdf} />]}
                />
                <ContentCardBody>
                    <Table responsive>
                        <THead>{cabecalho}</THead>
                        {!props.aguardando ? (
                            <TBody>
                                {faturasFiltradas.map((item, indice) => buildRow({ item, indice, getOnlyComponent: true }))}
                                {rodape}
                            </TBody>
                        ) : null}
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }

    function montarLinhas(faturas) {
        const linhas = [];

        for (const fatura of faturas) {
            const registro = buildRow({ item: fatura });
            const {
                componente,
                id_usuario_implantacao,
                msgErroImportacaoText,
                msgAlertaImportacaoText,
                nome_cliente,
                data_emissao,
                nome_concessionaria,
                nome_unidade_consumidora,
            } = registro;
            const totalCelulas = componente.props.children.length;
            let linhaModificada = Array.from(componente.props.children).splice(0, totalCelulas - 1);
            linhaModificada = React.Children.map(linhaModificada, (child, index) => {
                // Extrai propriedades personalizadas da linha original
                const backgroundColorTd = componente.props.backgroundColorTd || "";
                const backgroundColorTr = componente.props.backgroundColorTr || "";

                // 0 = Msg Erro Importação
                if (index === 0) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: (
                            <div>
                                {id_usuario_implantacao ? (
                                    <p
                                        style={{
                                            backgroundColor: "#257bfb",
                                            textAlign: "center",
                                            borderRadius: "0.3rem",
                                            color: "#fff",
                                            margin: "2px 10px 2px 2px",
                                            padding: "2px 5px",
                                        }}
                                    >
                                        Implantação
                                    </p>
                                ) : null}
                                <p
                                    style={{
                                        textAlign: "center",
                                        margin: "2px 10px 2px 2px",
                                        padding: "2px 5px",
                                    }}
                                >
                                    {msgErroImportacaoText.length > 30 ? msgErroImportacaoText.substring(0, 30) + "..." : msgErroImportacaoText}
                                </p>
                                <p
                                    style={{
                                        textAlign: "center",
                                        margin: "2px 10px 2px 2px",
                                        padding: "2px 5px",
                                    }}
                                >
                                    {msgAlertaImportacaoText.length > 30 ? msgAlertaImportacaoText.substring(0, 30) + "..." : msgAlertaImportacaoText}
                                </p>
                            </div>
                        ),
                    });
                }

                if (index === 2) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: (
                            <div
                                style={{
                                    width: 300,
                                    textAlign: "center",
                                }}
                            >
                                {nome_cliente.length > 20 ? nome_cliente.substring(0, 20) + "..." : nome_cliente}
                            </div>
                        ),
                    });
                }

                if (index === 3) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: (
                            <div
                                style={{
                                    textAlign: "center",
                                }}
                            >
                                {data_emissao ? (
                                    <p
                                        style={{
                                            textAlign: "center",
                                            fontSize: "0.8rem",
                                            margin: "0 0 5px 0",
                                        }}
                                    >
                                        Emitida em: {DateFormat.formatarDataSqlParaTela(data_emissao)}{" "}
                                    </p>
                                ) : null}
                            </div>
                        ),
                    });
                }

                if (index === 4) {
                    return React.cloneElement(child, {
                        backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                        children: (
                            <div
                                style={{
                                    width: 700,
                                    textAlign: "center",
                                }}
                            >
                                {nome_unidade_consumidora.length > 50
                                    ? `${nome_unidade_consumidora.substring(0, 50)}... (${nome_concessionaria})`
                                    : `${nome_unidade_consumidora} (${nome_concessionaria})`}
                            </div>
                        ),
                    });
                }

                // Retorna o elemento sem alterações, mas aplica os estilos personalizados
                return React.cloneElement(child, {
                    backgroundColor: index % 2 === 0 ? backgroundColorTd : backgroundColorTr,
                });
            });
            const linhaSemColunaBotoes = React.cloneElement(componente, {
                ...componente.props,
                children: linhaModificada,
                botoes: [],
            });

            linhas.push(linhaSemColunaBotoes);
        }
        return linhas;
    }

    function fecharModalAlertaErros() {
        setState({ ...state, exibirErros: false, conteudoModalAlertaErros: null });
    }

    function itemCorrespondeAoFiltro(item) {
        const brancos = !item.importacao_validada && !(item.erros || []).length && state.statusCorBranca;
        const verdes = item.importacao_validada && !(item.erros || []).length && state.statusCorVerde;
        const amarelas = item.importacao_validada && (item.erros || []).length && state.statusCorAmarela;
        const vermelhos = !item.importacao_validada && (item.erros || []).length && state.statusCorVermelha;
        const filtroPorCores = brancos || verdes || amarelas || vermelhos;
        const filtroUnidadesEmImplantacao = !state.apenasUnidadesEmImplantacao || item.id_usuario_implantacao;
        const filtroConcessionaria = !props.filtro.id_concessionaria || props.filtro.id_concessionaria == item.id_concessionaria_agua;
        const filtroApenasAlertas = !state.apenasAlertas || ((item.alertas.length || item.alertas.length > 1) && !item.alerta_verificado && item.importacao_validada);
        const filtroApenasAlertasVerificados = !state.apenasAlertasVerificados || item.alerta_verificado;

        return (
            filtroPorCores &&
            props.usuarioLogado &&
            (props.usuarioLogado.administrador || !vermelhos) &&
            filtroUnidadesEmImplantacao &&
            filtroConcessionaria &&
            filtroApenasAlertas &&
            filtroApenasAlertasVerificados
        );
    }

    function listarUCsFiltradas() {
        return props.listaUnidadeConsumidora.filter(
            (item) => (!props.filtro.id_cliente && props.usuarioLogado && props.usuarioLogado.administrador) || item.id_cliente == props.filtro.id_cliente
        );
    }

    function getMensagensErro(item) {
        //ignora aviso de fatura isenta, pois passou a ser listado como alerta, e não como erro
        const errosImportacao = (item.erros || []).map((erro) => erro.mensagem);

        const listaMensagensErroImportacaoHtml = (
            <ul style={{ minWidth: 150, paddingLeft: 20 }}>
                {errosImportacao.map((erro) => (
                    <li key={erro}> {erro}</li>
                ))}
            </ul>
        );
        const listaMensagensErroImportacaoText = errosImportacao.join("  |  ");

        const temErros = errosImportacao.length;
        const msgErroImportacaoHtml = item.arquivo_pdf ? (
            !temErros ? (
                item.importacao_validada ? (
                    "Validado"
                ) : (
                    "Importado"
                )
            ) : (
                <div style={{ fontSize: "0.8rem !important" }}>Verifique:{listaMensagensErroImportacaoHtml}</div>
            )
        ) : (
            "Não Importado"
        );

        const msgErroImportacaoText = item.arquivo_pdf
            ? !temErros
                ? item.importacao_validada
                    ? "Validado"
                    : "Importado"
                : `Verifique:${listaMensagensErroImportacaoText}`
            : "Não Importado";

        return { msgErroImportacaoHtml, msgErroImportacaoText };
    }

    function getMensagensAlerta({ item }) {
        //todos alertas e o aviso de TML sao não bloqueantes
        const errosAlertas = item.alertas.map((alerta) => alerta.mensagem);

        const listaMensagensAlertaImportacaoHtml = (
            <ul style={{ minWidth: 150, paddingLeft: 20 }}>
                {errosAlertas.map((alerta) => (
                    <li key={alerta}> {alerta}</li>
                ))}
            </ul>
        );
        const listaMensagensAlertaImportacaoText = errosAlertas.join("  |  ");

        const temAlertas = errosAlertas.length;
        const msgAlertaImportacaoHtml =
            item.arquivo_pdf && temAlertas ? (
                <div>
                    <div style={{ fontSize: "0.8rem !important" }}>Verifique:{listaMensagensAlertaImportacaoHtml}</div>
                    {item.alerta_verificado ? null : (
                        <Button
                            text='Marcar alerta como "Revisado"'
                            type={"success"}
                            icon={"fa fa-check"}
                            style={{ marginTop: 20 }}
                            // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/faturaAgua.js (verificarAlerta) e no endpoint PUT /api/fatura-agua/definir-alerta-verificado
                            event={() => {
                                props.setAlertaVerificado(item);
                                fecharModalAlertaErros();
                            }}
                        />
                    )}
                </div>
            ) : null;
        const msgAlertaImportacaoText = item.arquivo_pdf && temAlertas ? `Verifique: ${listaMensagensAlertaImportacaoText}` : "";

        return { msgAlertaImportacaoHtml, msgAlertaImportacaoText };
    }

    function gerarRelatorio({ statusAtivos, cabecalho, rodape, linhas }) {
        // props.setAguardando(true);
        const ucsSelecionadas = props.listaUnidadeConsumidora.filter((item) => props.filtro.unidades_consumidoras.find((uc) => uc.value == item.id));
        const nomesUcsSelecionadas = String(ucsSelecionadas.map((item) => item.valor));

        const totalCelulas = cabecalho.props.children.length;
        const linhaModificada = Array.from(cabecalho.props.children).splice(0, totalCelulas - 1);

        const cabecalhoSemColunasBotoes = (
            <NewTr>
                {linhaModificada.map((el, i) => {
                    const copia = React.cloneElement(
                        el,
                        {
                            key: i,
                            sticky: false,
                            style: { fontSize: "0.75rem", paddingTop: 30 },
                        },
                        [...el.props.children]
                    );
                    return copia;
                })}
            </NewTr>
        );

        const filtro = (
            <b style={{ fontSize: "0.75rem" }}>
                Cliente:
                {` ${(props.listaCliente.find((cliente) => cliente.id == props.filtro.id_cliente) || {}).valor || "Todos"} - `}
                UCs:
                {` ${nomesUcsSelecionadas.length ? nomesUcsSelecionadas : "Todas"} - `}
                Ano:{" " + (props.filtro.ano || "") + " - "}
                Mês:
                {` ${(props.listaMeses.find((mes) => mes.id == props.filtro.mes) || {}).valor || "Todos"} - `}
                Concessionária:
                {` ${(props.listaConcessionaria.find((concessionaria) => concessionaria.id == props.filtro.id_concessionaria) || {}).valor || "Todas"} - `}
                UCs: Filtro por Status: {String(statusAtivos).replace(/\,/g, ", ")}
            </b>
        );

        const html = ReactDOMServer.renderToString(
            <TabelaFaturaAdmPDF
                faturaAgua={true}
                height={1166}
                dadosImpressao={{
                    filtro,
                    rodape,
                    cabecalhoSemColunasBotoes,
                    linhas,
                }}
            />
        );

        props.gerarRelatorio({ html, landscape: true, scale: 0.96 });
        // props.setAguardando(false);

        // props.setArquivoPDF(pdfBase64, "Relatório faturas.pdf", "landscape");
    }
}

const mapStateToProps = (state) => {
    return {
        sessao: state.auth.usuario,
        usuarioLogado: state.auth.usuarioLogado,
        modoTela: state.fatura.modoTela,
        aguardando: state.fatura.aguardando,
        filtro: state.fatura.filtro,
        lista: state.fatura.listaAgua,
        listaCliente: state.fatura.listaClienteAgua,
        listaConcessionaria: state.fatura.listaConcessionariaAgua,
        listaUnidadeConsumidora: state.fatura.listaUnidadeConsumidoraAgua,
        listaMeses: state.fatura.listaMeses,
        pdf: state.displayPDF.pdf,
        nomePdf: state.displayPDF.nomePdf,
        orientation: state.displayPDF.orientation,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            setFiltro,
            salvar,
            excluir,
            getListaFaturasAdm,
            reprocessar,
            reprocessarTodas,
            setAlertaVerificado,
            buscarPdf,
            setArquivoPDF,
            setAguardando,
            gerarRelatorio,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(FaturaAguaAdm);
